import request from "../../utils/fetch";

// add data
export const addUser = (postData) => request.post(`subscription/admin/signup`, postData);